import ZSelect from './select.vue'

ZSelect.install = function(app) {
  app.component(ZSelect.name, ZSelect)
}

export default ZSelect